import React from "react";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import Button from "@mui/material/Button";
import useToasterStore from "store/SnackBar/useToasterStore";

const ToasterMessage = ({}) => {
  const { toasterOpen, alertType, message, closeToaster } = useToasterStore();
  const direction = alertType == "info" ? "right" : "center";

  return (
    <>
      <Snackbar
        open={toasterOpen}
        autoHideDuration={3000}
        onClose={closeToaster}
        className="bs-toaster"
        anchorOrigin={{ vertical: "bottom", horizontal: direction }}
      >
        <Alert
          className={`toaster-wrap ${alertType}`}
          onClose={closeToaster}
          severity={alertType}
          variant="filled"
        >
          <p className="toaster-desc">{message}</p>
        </Alert>
      </Snackbar>
    </>
  );
};

export default React.memo(ToasterMessage);
